'use strict';

angular.module('far.carousel', [])
    .directive('elCarousel', function ($window, $interval, $compile, $timeout) {
        return {
            scope: {
                items: '=elCarousel',
                interval: '=moveInterval',
                timeout: '@?'
            },
            restrict: 'A',
            templateUrl: function(element, attrs) {
                return attrs.templateUrl;
            },
            link: function (scope, elem) {
                elem.addClass('el-carousel');

                scope.prev = function() {
                    stopCarousel();

                    var firstElem = scope.items.pop();
                    scope.items.unshift(firstElem);
                }

                scope.next = function() {
                    stopCarousel();
                    moveItems();
                }

                function moveItems() {
                    var lastElem = scope.items.shift();
                    scope.items.push(lastElem);
                }

                var moveInterval, interval = scope.interval*1000;

                if (scope.items.length <= 2) {
                    elem.on('mouseleave', function() {
                        console.log('leave');
                        runCarousel();
                    });
                    elem.on('mouseenter', function() {
                        console.log('enter');
                        stopCarousel();
                    });
                    
                    if (scope.timeout) {
                        $timeout(function() {
                            runCarousel();        
                        }, scope.timeout);
                    } else {
                        runCarousel();            
                    }    
                }
                
                angular.element($window).bind('blur', stopCarousel);

                function stopCarousel() {
                    $interval.cancel(moveInterval);
                }

                angular.element($window).bind('focus', runCarousel);

                function runCarousel() {
                    moveInterval = $interval(moveItems, interval);
                }

                elem.bind('$destroy', function () {
                    $interval.cancel(moveInterval);
                    angular.element($window).unbind('blur', stopCarousel);
                    angular.element($window).unbind('focus', runCarousel);
                });
            }
        };
    });
